module.exports = {
    className: "CustomBlockMessage",
    classNameLabel: "Block Message App",
    limit: 10,
    showExport: false,
    columns: [
        {
            columnName: "objectId",
            type: "string"
        },
        {
            columnName: "name",
            type: "string"
        },
        {
            columnName: "message",
            type: "string"
        },
        {
            columnName: "createdAt",
            type: "Date"
        },
        {
            columnName: "updatedAt",
            type: "Date"
        }
    ]
}


// WEBPACK FOOTER //
// ./components/CustomBlockMessage/CustomBlockMessageSchema.js